import { Header } from 'semantic-ui-react';
import React from 'react';

export default
{
    demo: {
        todayIs: 'Danas je'
    },

    common: {
        bhs: 'B/H/S jezik',
        eng: 'Engleski jezik',
        group: 'Grupa',
        totalEcts: 'Ukupno ECTS bodova:',
        socialStatus: 'Socijalni status',
        academicStaff: 'Nastavno osoblje',
        notFound: 'Stranica ne postoji',
        courseRoleType: 'Uloga',
        courseDetails: 'Podaci o predmetu',
        details: 'Detalji',
        ordinal: 'R. br.',
        comment_: 'Napomena',
        logout: 'Odjava',
        editAdd: 'Dodavanje / izmjena',
        add: 'Dodaj',
        send: 'Pošalji',
        cancel: 'Poništi',
        cancelO: 'Odustani',
        ok: 'Potvrdi',
        firstName: 'Ime',
        lastName: 'Prezime',
        lastNameAndFirstName: 'Prezime i ime',
        studentLastNameAndFirstName: 'Prezime i ime studenta/ice',
        dateOfAbandonment: 'Datum ispisa',
        maidenName: 'Djevojačko prezime',
        student: 'Student/ica',
        index: 'Index',
        degree: 'Broj diplome',
        edit: 'Izmijeni',
        save: 'Sačuvaj',
        delete: 'Obriši',
        language: 'Jezik',
        comment: 'Napomena',
        date: 'Datum',
        courseName: 'Predmet',
        back: 'Nazad',
        confirm: 'Potvrdi',
        show: 'Prikaži',
        grade: 'Ocjena',
        teacher: 'Nastavnik',
        semester: 'Semestar',
        course: 'Predmet',
        courses: 'Predmeti',
        faculty: 'Fakultet',
        faculties: 'Fakulteti',
        academicYear: 'Akademska godina',
        municipality: 'Općina',
        unsa: 'Univerzitet u Sarajevu',
        studyCycle: 'Studijski ciklus',
        citizenship: 'Državljanstvo',
        process: 'Obrađuje se...',
        successfully: 'Uspješno...',
        studentsList: 'Popis studenata',
        graduatedDate: 'Datum diplomiranja',
        yes: 'DA',
        no: 'NE',
        areYouSure: 'Jeste li sigurni?',
        info: 'Informacije',
        error: 'Došlo je do greške!',
        oneExamRestrictionError: 'Na ovom ispitnom roku možete prijaviti samo jedan ispit!',
        lecture: 'Predavanja (broj sati)',
        exercise: 'Vježbe (broj sati)',
        lectureExerciseSeminar: 'P + V + S',
        lectureExerciseSeminarAbr: 'P + V + S',
        select: 'Označi',
        chose: 'Odaberi',
        average: 'Prosjek',
        gradeAverage: 'Prosjek ocjena: ',
        studyProgram: 'Studijski program',
        studyType: 'Vrsta studija',
        contact: 'Kontakt',
        department: 'Odsjek',
        jmbg: 'JMBG',
        oid: 'OID',
        username: 'Korisničko ime',
        accountMail: 'Korisnički e-mail',
        dateOfBirth: 'Datum rođenja',
        gender: 'Spol',
        father: 'Ime i prezime oca',
        mother: 'Ime i prezime majke',
        fatherName: 'Ime oca',
        motherName: 'Ime majke',
        placeOfBirth: 'Mjesto rođenja',
        residence: 'Mjesto prebivališta',
        currentResidence: 'Mjesto boravišta',
        nationality: 'Nacionalnost',
        classroom: 'Učionica',
        noResultMessage: 'Nema pronađenih rezultata!',
        description: 'Opis/napomena',
        phone: 'Telefon',
        mail: 'E-mail',
        studyAddress: 'Adresa boravišta',
        cantonResidence: 'Kanton prebivališta',
        municipalityResidence: 'Općina prebivališta',
        addressResidence: 'Adresa prebivališta',
        archive: 'Arhiviraj',
        courseCode: 'Šifra predmeta',
        code: 'šifra',
        startPage: ' ',
        editOrAdd: 'Dodavanje / izmjena',
        coursesList: 'Popis predmeta',
        leadStaff: 'Nosilac predmeta',
        filterRequired: 'Morate unijeti po čemu želite filtrirati!',
        studyProgramName: 'Naziv smjera (studijskog programa)',
        selectStudyProgram: 'Odaberite smjer (studijski program)',
        inputIndex: 'Unesite broj indexa',
        inputName: 'Unesite ime',
        inputLastName: 'Unesite prezime',
        personalInfo: 'Osobni podaci',
        students: 'Studenti',
        courseType: 'Vrsta predmeta',
        mandatory: 'Obvezni',
        optional: 'Izborni',
        notice: 'Obavijesti',
        notification: 'Obavijest',
        notifications: 'Obavijesti',
        inputNotification: 'Unesite obavijest..',
        newNotifications: 'Nove obavijesti',
        newNotification: 'Nova obavijest',
        markAllAsRead: 'Označi sve kao pročitano',
        new: 'NOVO',
        activeNotifications: 'Aktivne obavijesti',
        previousNotifications: 'Prethodne obavijesti',
        noNewNotifications: 'Nemate novih obavijesti.',
        noActiveNotifications: 'Nemate aktivnih obavijesti',
        noPreviousNotifications: 'Nemate prethodnih obavijesti',
        title: 'Naslov obavijesti',
        notificationType: 'Vrsta obavijesti',
        notificationStartDate: 'Datum objave',
        notificationEndDate: 'Datum isteka',
        recipientsProfessors: 'Primatelji obavijesti (Profesori)',
        recipientsEmployees: 'Primatelji obavijesti (Zaposlenici)',
        recipientsStudents: 'Primatelji obavijesti (Studenti)',
        requiredFields: 'Niste popunili sva obvezna polja.',
        requiredEmailForm: 'Unesite ispravnu email adresu.',
        notificationSent: 'Obavijest je uspješno poslana.',
        notificationSentError: 'Došlo je do greške! Slanje obavijesti nije uspješno izvršeno.',
        employees: 'Zaposlenici',
        professors: 'Profesori',
        section: 'Sekcija',
        intervalStart: 'Od',
        intervalEnd: 'Do',
        image: 'Fotografija studenta',
        semesterName: 'Naziv semestra',
        semesterNumber: 'Broj semestra',
        applicationDate: 'Datum prijave ispita',
        english: 'Engleski jezik',
        bosnian: 'B / H / S',
        startEngagement: 'Početak angažmana',
        endEngagement: 'Kraj angažmana',
        titleElection: ' Izbor u zvanje',
        academicTitle: 'Zvanje',
        titleExpiration: 'Istek zvanja',
        noEmploymentInfo: 'Podaci o zvanju zaposlenika nisu uneseni. Obratite se HR administratoru.',
        noPositionInfo: 'Podaci o poziciji zaposlenika nisu uneseni. Obratite se HR administratoru.',
        filterStudents: 'Pretraga studenata',
        noData: 'Nema podataka',
        noDataToDisplay: 'Nema podataka za prikaz.',
    },
    poll: {
        polls: 'Ankete',
        access: 'Pristup',
        accessProhibited: 'zabranjen',
        accessGranted: 'odobren',
        ban: 'Zabrani',
        approve: 'Odobri',
        results: 'Rezultati',
        pollResults: 'Rezultati ankete',
        reviewResults: 'Pregled rezultata',
        question: 'Pitanje',
        questions: 'Pitanja',
        active: 'Aktivne ankete',
        created: 'Kreirane ankete',
        archived: 'Arhivirane ankete',
        pollTitle: 'Naziv ankete',
        title: 'Naziv',
        type: 'Vrsta',
        startDate: 'Datum objave',
        endDate: 'Datum isteka',
        pollDetails: 'Detalji ankete',
        details: 'Detalji',
        edit: 'Uredi',
        delete: 'Obriši',
        overview: 'Pregled anketa',
        createNewPoll: 'Kreiraj novu anketu',
        newPoll: 'Nova anketa',
        creatingPoll: 'Kreiranje ankete',
        pollType: 'Vrsta ankete',
        comment: 'Komentar',
        placeholderPollName: 'Unesite naziv',
        placeholderType: 'Odaberite vrstu',
        placeholderDate: 'Unesite datum',
        placeholderComment: 'Unesite komentar..',
        placeholderAnswer: 'Unesite odgovor',
        placeholderQuestion: 'Unesite pitanje',
        placeholderOfferedAnswer: 'Unesite ponuđeni odgovor',
        createPollButton: 'Kreiraj anketu',
        cancel: 'Odustani',
        addQuestionButton: 'Dodaj pitanje',
        addAnswerButton: 'Dodaj odgovor',
        offeredAnswers: 'Ponuđeni odgovori',
        section: 'Sekcija',
        placeholderAssistants: 'Odaberite asistente',
        placeholderProfessors: 'Odaberite profesore',
        numberOfStudentsOnCourse: 'Broj studenata na predmetu',
        numberOfStudentsWhoDoneCourse: 'Broj studenata koji su ocijenili predmet',
        numberOfStudentsWhoDoneProfessor: 'Broj studenata koji su ocijenili profesora',
        numberOfStudentsWhoDoneAssistant: 'Broj studenata koji su ocijenili asistenta',
        coursesOnPoll: 'Popis predmeta na anketi',
        noCoursesMess: 'Vaši predmeti se ne nalaze na odabranoj anketi.',
        noPollMess: 'Trenutno nema kreiranih anketa.',
        noStudentsMess: 'Na odabranom predmetu nema studenata.',
        lateImplementationMess: ' Implementacija predmeta je kreirana nakon početka anketiranja.',
        noCoursesAssigned: 'Niste dodijeljeni na predmete u ovom semestru.',
        sp: 'Smjer',
        noDataForExcelExport: "Došlo je do greške. Nema podataka za Excel izvoz.",
        errorWhileExcelExport: "Došlo je do greške prilikom izvoza u Excel datoteku.",
        successfullExcelExport: "Uspješno ste izvezli podatke u Excel datoteku.",
    },
    sidebar: {
        home: 'Početna',
        personalInfo: 'Osobni podaci',
        study: 'Studij',
        gradesOverview: 'Ocjene',
        coursesOverview: 'Nastavni plan i program',
        collision: 'Kolizioni predmeti',
        optional: 'Izborni predmeti',
        currentSemesterCourses: 'Trenutni semestar',
        exams: 'Ispiti',
        activeExams: 'Aktivni ispiti',
        finalizedExams: 'Završeni ispiti',
        register: 'Prijava ispita',
        registeredExams: 'Prijavljeni ispiti',
        documents: 'Dokumenti',
        reports: 'Izvještaji',
        comment: 'Komentari i prijedlozi',
        contact: 'Kontakt informacije',
        courses: 'Predmeti',
        statistic: 'Statistika',
    },

    route: {
        home: 'Početna',
        personalInfo: '/osobni-podaci-studenta',
        collisionCourses: '/kolizioni-predmeti',
        optionalCourses: '/izborni-predmeti',
        currentSemesterCourses: '/predmeti-u-trenutnom-semestru',
        gradesOverview: '/pregled-ocjena',
        coursesOverview: '/nastavni-plan-i-program',
        passedExams: '/položeni-ispiti',
        registerExams: '/prijava-ispita',
        registeredExams: '/prijavljeni-ispiti',
        requests: '/dokumenti',
        reports: '/izvjestaji',
        comments: '/komentari-i-prijedlozi',
        contact: '/kontakt-informacije',

        finalized: '/završeni-ispiti',
        studentGrades: '/završeni-ispiti/popis-studenata',
        examStatistic: '/završeni-ispiti/statistika',
        active: '/aktivni-ispiti',
        inputGrades: '/aktivni-ispiti/unos-ocjena',
        filterStudentsForProfessor: '/studenti',
        studentsInfoFromSearch: '/studenti/profil',
        studentGradesAndInfo: '/aktivni-ispiti/unos-ocjena/podaci-o-studentu',
        studentGradesAndInfoFromFinalised: '/završeni-ispiti/popis-studenata/podaci-o-studentu',
        upcomingExams: '/predstojeći-ispiti',
        statistic: '/statistika-za-profesore',
        personalInf: '/osobni-podaci',
        courses: '/popis-predmeta',
        studentsInfo: '/popis-predmeta/studenti/podaci',
        studentsInfoSS: '/nastavno-osoblje/predmeti/studenti/detalji',
        students: '/popis-predmeta/studenti',
        courseDetails: '/popis-predmeta/detalji',
        courseStudents: '/popis-predmeta/studenti',
        courseStatistic: '/popis-predmeta/statistika',
        registeredStudents: '/prijavljeni-studenti',
        academicStaff: '/nastavno-osoblje',

        polls: '/ankete',
        pollCourses: '/ankete/predmeti',
        pollResults: '/ankete/predmeti/rezultati',
        access: '/pristup-anketi',
        accessCourses: '/pristup-anketi/predmeti',
        accessStudents: '/pristup-anketi/predmeti/studenti',
        faq: '/pitanja-i-odgovori',


    },

    orgUnitDetailed: {
        orgUnits: 'Organizacione jedinice',
        parents: 'Roditelji',
        types: 'Tipovi',
        addOrgUnitType: 'Dodaj tip',
        staffPosition: 'Pozicija',
        staff: 'Staff',
        addresses: 'Adrese',
        addressesDesc: 'Sve adrese ove organizacione jedinice',
        street: 'Ulica',
        place: 'Mjesto',
        contacts: 'Kontakti',
        addContacts: 'Dodaj kontakt',
        contactValue: 'Vrijednost',
        contactDescription: 'Opis',
        contactType: 'Tip',
        name: 'Ime',
    },

    student: {
        exams: 'Ispiti',
        canceled: 'Uspješno ste odjavili ispit.',
        registered: 'Uspješno ste prijavili ispit.',
        summerSemester: 'Ljetni semestar',
        winterSemester: 'Zimski semestar',
        studyProgramView: 'Nastavni plan i program',
        collision: 'Kolizija',
        availableCollision: 'Dostupni kolizioni predmeti',
        theRestEcts: 'Preostalo ECTS: ',
        currentCourses: 'Odabrani izborni predmeti',
        currentSemesterCourses: 'Predmeti u trenutnom semestru',
        noCollisionMessage: 'Trenutno predmete koje možete koliziono prijaviti.',
        noCoursesMessage: 'Nemate odabranih izbornih predmeta.',
        noCurrentSemesterMessage: 'Niste upisani u trenutni semestar, te iz tog razloga ne možete vidjeti predmete. Obratite se studentskoj službi fakulteta/akademije.',
        selectOptionalCourse: 'Potvrdi izbor',
        optionalCourses: 'Izborni predmeti',
        availableOptionalCourses: 'Dostupni izborni predmeti',
        noElectiveMessage: 'Trenutno nemate predmete koje možete prijaviti kao izborne predmete.',
        study: 'Studij',
        showGrades: 'Pregled ocjena',
        noGradesMessage: 'Nemate ocjena.',
        deleteContactToast: 'Kontakt je uspješno obrisan!',
        editContactToast: 'Kontakt je uspješno izmijenjen!',
        editContactErrToast: 'Došlo je do greške! Kontakt nije izmijenjen!',
        addContactToast: 'Kontakt je uspješno dodat!',
        basicInfo: 'Osnovni podaci',
        previousEducation: 'Prethodno obrazovanje',
        currentStudy: 'Trenutni studij',
        examDate: 'Datum polaganja',
        registeredExams: 'Prijavljeni ispiti',
        noRegisteredExamsMessage: 'Nemate prijavljenih ispita.',
        currentRegisteredExams: 'Trenutno prijavljeni ispiti',
        allRegisteredExams: 'Prethodno prijavljeni ispiti',
        noPreviousRegisteredExamsMessage: 'Nemate prethodno prijavljenih ispita.',
        cancelExam: 'Odjavi ispit',
        registerExam: 'Prijava ispita',
        register: 'Prijavi ispit',
        noExamsForRegisterMessage: 'Nemate ispita koje možete prijaviti.',
        addNewContact: 'Dodavanje novog kontakta',
        noContactInfo: 'Nema kontakt informacija.',
        passedExamsNumber: 'Broj položenih ispita',
        noCurrentSemesterCourses: 'Niste upisani ni na jedan predmet u ovome semestru.',
        registeredStudentsList: 'Popis prijavljenih studenata',
        accountInfo: 'Podaci korisničkog računa',
        userRole: 'Korisničke uloge'

    },

    studentDocuments: {
        documentType: 'Vrsta dokumenta',
        status: 'Status',
        add: 'Kreiraj zahtjev',
        editRequest: 'Izmjena postojećeg zahtjeva',
        docRequest: 'Trenutni zahtjevi',
        createRequest: 'Kreiranje novog zahtjeva',
        requests: 'Dokumenti',
        send: 'Pošalji',
        certificateType: 'Vrsta potvrde',
        selectCertificateType: 'Izaberite vrstu potvrde',
        certificateReason: 'Statusna potvrda',
        selectCertificateReason: 'Izaberite statusnu potvrdu',
        selectLanguage: 'Izaberite jezik',
        writeComment: 'Napišite detalje zahtjeva',
        previousDocRequest: 'Prethodni zahtjevi',
        CurrentRequestMessage: 'Trenutno nemate aktivnih zahtjeva za dokumente.',
        PreviousRequestMessage: 'Nemate prethodnih zahtjeva za dokumente.',
        sentRequestToast: 'Zahtjev uspješno poslan.',
        errSentRequestToast: 'Došlo je do greške, zahtjev nije poslan.',
        errSentRequestDuplicateToast: 'Zahtjev za izdavanje ovog dokumenta je već kreiran.',
        cancelRequestToast: 'Zahtjev je poništen.',
        cancelPopup: 'Ovaj zahtjev će biti poništen!',
        showPopup: 'Prikaz prethodnih zahtjeva.',
        errInputToast: 'Niste unijeli sva polja!'
    },
    professorInputGrades: {
        finalizeInfo: 'Nakon što završite ispit svim neocijenjenim studentima sustav će dodijeliti ocjenu',
        finalizeInfo2: 'nije pristupio/la.',
        grade: 'Ocijeni',
        groupGrading: 'Grupno ocjenjivanje',
        groupGradingInfo: 'Grupno ocjenjivanje možete izvršiti tako što studente/ice sa istom ocjenom označite na listi ' +
            '(klikom na red tabele ili na kvadratić u prvoj koloni), potom izaberete ocjenu i klikom na ',
        groupGradingInfo2: 'Ocijeni',
        groupGradingInfo3: ' svim označenim studentima/icama će biti unesena odabrana ocjena.',
        individuallyGrading: 'Pojedinačno ocjenjivanje',
        infoView: 'Pregled podataka',
        info: 'Podaci',
        personalInfo: 'Osobni podaci',
        semesters: 'Pregled semestara',
        currentSemester: 'Trenutni semestar',
        studyInfo: 'Trenutni studij',
        finalizeCheck: 'Jeste li sigurni da želite završiti ispit?',
        endOfEmploymentDate: 'Datum prestanka radnog odnosa',
        endOfEmployment: 'Prestanak radnog odnosa',
        endOfEmploymentButton: 'Prekini radni odnos',
        contact: 'Kontakt informacije',
        inputGrades: 'Unos ocjena',
        selectCourse: 'Izaberite predmet',
        selectExamTerms: 'Izaberite vrstu ispita',
        selectGrade: 'Ocjena',
        examType: 'Vrsta ispita',
        attention: 'Izlaznost',
        registration: 'Prijave',
        passed: 'Prolaznost',
        course: 'Predmet',
        confirm: 'Potvrdi',
        studentsWithoutGrades: 'Popis neocijenjenih studenata',
        studentsWithGrades: 'Popis ocijenjenih studenata',
        studyYear: 'Studijska godina',
        department: 'Odsjek',
        studyProgram: 'Studijski program',
        studentStudyType: 'Vrsta studija',
        selectStudyType: 'Izaberite status studenta',
        selectStudyProgram: 'Izaberite smjer (studijski program)',
        selectDate: 'Izaberite datum ispita',
        graded: 'Ocijeni',
        edit: 'Izmijeni',
        confirmGrade: 'Potvrdi ocjenu',
        cancelGrade: 'Poništi ocjenu',
        filterData: 'Filtriraj podatke.',
        showTable: 'Prikaži ocijenjene studente.',
        CurrentGradesMessage: 'Nema neocijenjenih studenata.',
        CurrentGradesFilterMessage: 'Filtriranje je uključeno! Nema neocijenjenih studenata.',
        PreviousGradesMessage: 'Nema ocijenjenih studenata.',
        PreviousGradesFilterMessage: 'Filtriranje je uključeno! Nema ocijenjenih studenata.',
        PreviousNoGradesFilterMessage: 'Filtriranje je uključeno! Nema neocijenjenih studenata.',
        selectAcademicYear: 'Izaberite akademsku godinu',
        selectSemester: 'Izaberite semestar',
        examDate: 'Ispitni rok',
        examDateDate: 'Datum i vrijeme ispita',
        examFinalizationTime: 'Datum i vrijeme automatskog finaliziranja',
        examOnlyDate: 'Datum ispita',
        selectExamDate: 'Odaberite ispitni rok',
        showStudents: 'Prikaži studente',
        selectNewCourse: 'Odaberite drugi predmet',
        inputFirstName: 'Unesite ime',
        inputLastName: 'Unesite prezime',
        FiltersOn: 'Filtriranje uključeno!',
        getFilter: 'Filtriraj',
        finalize: 'ZAVRŠI   ISPIT',
        toastFilter: 'Odaberite po čemu želite filtrirati podatke!',
        toastFilterFailed: 'Filtriranje nije uspjelo',
        toastFilanizedExam: 'Ispit je završen!',
        toastStudentGraded: 'Student je uspješno ocijenjen!',
        toastStudentsGraded: 'Studenti su uspješno ocijenjeni!',
        toastStudentGradedFailed: 'Student nije ocijenjen, došlo je do greške!',
        toastStudentsGradedFailed: 'Studenti nisu ocijenjeni, došlo je do greške!',
        activeExamsList: 'Popis aktivnih (nezavršenih) ispita',
        NoDataMessage: 'Nema aktivnih ispita.',
        numberOfStudents: 'Broj prijavljenih studenata',
        gradeStudents: 'Ocjenjivanje',
        registeredStudents: 'Prijavljeni studenti',
        activeCourse: 'Aktivni ispiti',
        finalizedCourse: 'Završeni ispiti',
        finalizedCourseList: 'Popis završenih ispita',
        toastStudentGradeEdited: 'Ocjena je uspješno izmijenjena.',
        toastStudentGradeCancel: 'Ocjena je uspješno poništena.',
        toastStudentGradeEditFailed: 'Došlo je do greške, ocjena nije izmijenjena!',
        toastStudentGradeCancelFailed: 'Došlo je do greške, ocjena nije poništena!',
        startDate: 'Ispiti od:',
        endDate: 'Ispiti do:',
        NofinalizedExamsMessage: 'Nema završenih ispita.',
        endAndStartDate: 'Morate unijeti od kojeg do kojeg datuma želite ispite!',
        toastFinalizedFailed: 'Ispit nije završen!',
        NoUpcomingExamsMessage: 'Nemate predstojećih ispita.',
        upcomingExams: 'Predstojeći ispiti',
        upcomingExamsList: 'Popis predstojećih ispita',
        toastFinalized: 'Ispit je uspješno završen!',
        studentInfo: 'Podaci o studentu',
        showStudentInfo: 'Prikaži informacije o studentu',
        backToStudentsList: 'Nazad na popis studenata',
        gradesList: 'Popis ocjena',
        inputGradeDate: 'Datum unosa ocjene',
        positions: 'Radne pozicije',
        titles: 'Izbori u zvanje',
        inputCourseName: 'Unesite naziv predmeta',
        gradedStudentsNumber: 'Broj ocijenjenih studenata',
        averageGrade: 'Prosječna ocjena: ',
        noDataForAcademicYear: 'Nema podataka.',
        noCourses: 'Nema predmeta',
        noCoursesMessage: 'Nema predmeta za koje ste zaduženi ove akademske godine.',
        noCoursesMessageSS: 'Nema predmeta za koje je profesor/ica zadužen/a u odabranoj akademskoj godini.',
        noCoursesFilter: 'Filtriranje je uključeno! Nema predmeta.',
        gradedStudents: 'Ocijenjeni studenti',
        notGradedStudents: 'Neocijenjeni studenti',
        printGradesList: ' Ocijenjeni studenti po indexima',
        printStudentsList: ' Prijavljeni studenti',
        finalizationCancelDate: 'Datum ponovnog otvaranja ispita (odluka)',
    },
    professorStatistics: {
        statistics: 'Statistika',
        numberOfStudents: 'Broj studenata na predmetu',
        averrageGrade: 'Prosjek ocjena',
        NoDataMessage: 'Nema podataka za ovu akademsku godinu.',
        currentAcademicYear: 'Trenutna akademska godina',
        studentsChart: 'Prikaz broja studenata po predmetu',
        gradeChart: 'Prikaz prosječne ocjene po predmetu',
        graphicShow: 'Grafički prikaz',
        tableShow: 'Tabelarni prikaz',
        courseId: 'Redni broj',
        selectAcademicYear: 'Odaberite akademsku godinu',
        academicYearHeader: ' akademska godina',
        courseStatistic: 'Statistika predmeta',
        statisticForCourse: 'Statistika za predmet: ',
        noStudents: 'Nema studenata.',
        noCourses: 'Nema podataka o odabranom predmetu.',
        noStudentsFilter: 'Filtriranje je uključeno! Nema studenata.',
        printRegisteredStudents: 'Tiskanje popisa prijavljenih studenata',
        printStudentGrades: ' Tiskanje popisa studenata sa ocjenama',
        notFinalRegisteredStudentsList: '*Popis prijavljenih studenata nije konačan, jer je ispit još uvijek otvoren za prijavu. ',
        noRegisteredStudents: 'Nema prijavljenih studenata.',
        studyProgramCourse: 'na kojem se izvodi predmet',
        courseExamDate: 'Naziv predmeta / vrsta ispita / datum',
        numberOfStudentsOnCourse: 'Broj studenata koji pohađaju predmet',
        numberOfDistinctStudentGradedActivities: 'Broj različitih prijavljenih studenata na svim ispitima',
        numberOfExamRegistrations: 'Ukupan broj prijava na svim ispitima',
        numberOfDistinctStudentsWhoAccessedExam: 'Broj različitih studenata koji su izašli na ispite',
        numberOfStudentsWhoAccessedExam: 'Ukupan broj izlazaka na svim ispitima',
        numberOfStudentsWhoPassed: 'Broj studenata koji su položili predmet',
        averagePassed: 'Prolaznost',
        five: '5 (pet)',
        six: '6 (šest)',
        seven: '7 (sedam)',
        eight: '8 (osam)',
        nine: '9 (devet)',
        ten: '10 (deset)',
        nonp: 'nije ocijenjen/nije pristupio',
        io: 'ispunio obveze',
        nz: 'nije zadovoljio',
        z: 'zadovoljio',
        no: 'nije obranio',
        uo: 'uspješno obranio',
        courseName: 'Naziv predmeta'
    },
    contact: {
        contact: 'Kontakt informacije',
        unsa: 'UNSA',

        selectCommentType: 'Odaberite vrstu komentara',
        inputMail: 'Unesite e-mail adresu',
        inputTitle: 'Unesite naslov',
        text: 'Tekst poruke...',
        text_: 'Tekst poruke',
        title: 'Naslov poruke',
        email: 'Vaša e-mail adresa',
        comments: 'Komentari i prijedlozi',
        form: 'Forma za slanje',
        errorMess: 'Niste unijeli sva obavezna polja.',
        mailValidationError: 'Mail adresa nije ispravna.',
        success: 'Vaš komentar / prijedlog je uspješno poslan.',
        error: 'Došlo je od greške! Vaš komentar / prijedlog nije poslan.',
    },

    statistics: {
        statistic: 'Statistika',
        selectFacultyAndAcademicYear: 'Odaberite fakultet i akademsku godinu',
        selectFacultyAcademicYearAndStudyCycle: 'Odaberite fakultet, akademsku godinu i studijski ciklus',
        selectFaculty: 'Odaberite fakultet',
        selectAcademicYear: 'Odaberite akademsku godinu',
        selectStudyCycle: 'Odaberite studijski ciklus',
        citizenship: 'Državljani',
        selectCitizenship: 'Odaberite državljanstvo studenata',
        headerNumberEnrolledStudents: 'Broj upisanih studenata u prvi semestar ',
        headerAcademicYear: ' akademske godine',
        tableShow: 'Tabelarni prikaz',
        graphicShow: 'Grafički prikaz',
        place: 'Mjesto',
        numberOfStudents: 'Broj studenata',
    }


    };



// WEBPACK FOOTER //
// ./src/messages/messages_hr.js